<template>  
  <div>
    <q-card inline style="width: 280px">
      <q-card-title>
        <q-toolbar color="primary">
        <q-toolbar-title>
          {{ title }}
        </q-toolbar-title>
        </q-toolbar>
      </q-card-title>
      <q-card-separator />
      <q-card-main>
        <q-input v-model="FirstName" :stack-label="$t('global.NameFirst')" />
        <p class="error" v-if="submited && FirstNameError">{{ FirstNameError }}</p>
        
        <q-input v-model="LastName" :stack-label="$t('global.Name')" />
        <p class="error" v-if="submited && LastNameError">{{ LastNameError }}</p>
        <q-input v-model="Email" type="email" :stack-label="$t('global.UserEmail')" />
        <p class="error" v-if="submited && EmailError">{{ EmailError }}</p>
        <div v-if="IdUser == null">
          <q-input v-model="Password" type="text" :stack-label="$t('global.Password')" />
          <p class="error" v-if="submited && PasswordError">{{ PasswordError }}</p>
        </div>
        <q-select
          v-model="selectedCategory"
          :float-label="$t('global.Category')"
          :options="optionsCategory"
          :display-value="DisplayCategory"
         />  
        <p class="error" v-if="submited && selectedCategoryError">{{ selectedCategoryError }}</p>
        <q-input v-model="Address" :stack-label="$t('global.Address')" />
        <p class="error" v-if="submited && AddressError">{{ AddressError }}</p>
        <q-checkbox v-model="IsHourlyWage" :label="$t('global.HourlyWage')"  />
        <q-input v-model="MonthlyWage" type="number" :stack-label="$t('global.MonthlyWage')" />
        <q-input v-model="HoursMonthlyWage" type="number" :stack-label="$t('global.HoursMonth')" />
        <q-input v-model="HourlyWage" type="number" :stack-label="$t('global.HourlyWage')" />
        <q-input v-model="Comment" :stack-label="$t('global.Comment')" />  
        <q-checkbox v-model="IsActive" :label="$t('global.Active')"  />
        <p></p>
        <q-btn class="button" @click="saveUser()" color="primary" :label="$t('global.Save')" /> 
      </q-card-main>
    </q-card>   
  </div>
</template>

<script>
import {eventBus} from '../main'
import axios from 'axios'
import qs from 'qs'

export default {
  name: 'SideDialogGeoRegionNew',
  data () {
    return {
      FirstName: '',
      FirstNameError: null,
      LastName: '',
      LastNameError: null,
      Email: '',
      EmailError: null,
      Password: '',
      PasswordError: null,
      Address: '',
      AddressError: null,
      IsHourlyWage: false,
      HourlyWage: 0,
      MonthlyWage: 0,
      HoursMonthlyWage: 0,
      Comment: null,
      IsActive: true,
      AccessLevel: 100,
      selectedCategory: null,
      DisplayCategory: null,
      selectedCategoryError: null,
      optionsCategory: [],
      form: {
        SessionId: null,
        action: 'InsertUser',
      },
      submited: false,
      title: null,
      validationRequired: this.$t('global.EntryRequired'),
      validationEmail: this.$t('global.InvalidEmail'),
      validationPassword: this.$t('global.NotSafeEnugh')
      
    }
  },
  props: ['IdUser'],
  methods: {
    saveUser(){
      this.submited = true
      if(this.validate()){
        this.insertUser()
      }
    },

    validate(){

        var valid = true

        if(this.FirstName == ''){
          this.FirstNameError = this.validationRequired
          valid = false
        }
        else{
          this.FirstNameError = null
        }

        if(this.LastName == ''){
          this.LastNameError = this.validationRequired
          valid = false
        }
        else{
          this.LastNameError = null
        }

        if(this.Email == ''){
          this.EmailError = this.validationRequired
          valid = false
        }
        else{
          if(!validateEmail(this.Email)){
            this.EmailError = this.validationEmail
            valid = false
          }
          else{
            this.EmailError = null
          }  
        }

        if(this.Address == ''){
          this.AddressError = this.validationRequired
          valid = false
        }
        else{
          this.AddressError = null
        }

        if(this.IdUser == null){ //Password Validation only on insert new user
          if(this.Password == ''){
            this.PasswordError = this.validationRequired
            valid = false
          }
          else{
            if(!testPassword(this.Password)){
              this.PasswordError = this.validationPassword
              valid = false
            }
            else{
              this.PasswordError = null
            }
          }
        }

        if(this.selectedCategory == null){
          this.selectedCategoryError = this.validationRequired
          valid = false
        }
        else{
          this.selectedCategoryError = null
        }

      return valid
    },

    insertUser(){
      this.form.SessionId = this.$store.state.session.SessionId
      if(this.IdUser == null){
          this.form.action = "NewUser"
      }
      else{
         this.form.action = "UpdateUser"
         this.form.IdUser = this.IdUser
      }
      
      this.form.FirstName = this.FirstName
      this.form.LastName = this.LastName
      this.form.Email = this.Email
      this.form.Address = this.Address
      this.form.Password = this.Password
      this.form.IsHourlyWage = this.IsHourlyWage
      this.form.HourlyWage = this.HourlyWage
      this.form.MonthlyWage = this.MonthlyWage
      this.form.HoursMonthlyWage = this.HoursMonthlyWage
      this.form.Comment = this.Comment
      this.form.IsActive  = this.IsActive
      this.form.IdUserCategory = this.selectedCategory
      var self = this
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          if(response.status == 200){ 
             if(response.data == "OK"){
              if(this.IdUser == null){
                  this.$q.notify({ message: this.$t('global.Created'), type: 'positive' })
                  this.initUser()
              }
              else{
                 this.$q.notify({ message: this.$t('global.WorkChanged'), type: 'positive' })
              }
              eventBus.$emit('Bus_UserUpdate', null)
              eventBus.$emit('closeDialog', null)
              this.submited = false
             }
             else{
               if(response.data == "-1"){
                 self.EmailError = this.$t('global.EmailAlreadyRecorded')
               }
               else{
                this.$q.notify('Something Wrong.')
               }
             }
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e);
      })
    },
    initUser(){
      this.FirstName = ''
      this.LastName = ''
      this.Email = ''
      this.Address = ''
      this.Password = ''
      this.IsHourlyWage = false
      this.HourlyWage = 0
      this.MonthlyWage = 0
      this.HoursMonthlyWage = 0
      this.Comment = ''
      this.IsActive = true
      this.selectedCategory = null
      this.DisplayCategory = null
    },
    dataInit(){
       this.submited = false
       if(this.IdUser == null){
         this.title = this.$t('global.InsertEmployee')
         this.initUser();
       }
       else{
         this.title = this.$t('global.EditEmployee')
         this.loadUser()
       }
    },
    
    loadUser(){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "GetUser"
      this.form.IdUser = this.IdUser
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          if(response.status == 200){ 
              var user = response.data
              this.FirstName = user.FirstName
              this.LastName = user.LastName
              this.Email = user.Email
              this.Address = user.Address
              this.IsHourlyWage = user.IsHourlyWage
              this.MonthlyWage = user.MonthlyWage
              this.HourlyWage = user.HourlyWage
              this.HoursMonthlyWage = user.HoursMonthlyWage
              this.Comment = user.Comment
              this.IsActive = user.IsActive
              //Set Combo Box:
              
              this.IdUserCategory = user.IdUserCategory
              this.selectedCategory = user.IdUserCategory
              this.DisplayCategory = user.UserCategory

          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e);
      })
      
    },
    calcHourlyWage(){
      if(this.MonthlyWage  != null && this.HoursMonthlyWage != null){
        this.HourlyWage = round(this.MonthlyWage / this.HoursMonthlyWage, 2)
      }
    }


  },
  created () { 
    this.dataInit()
    this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "GetUserCategory"
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          if(response.status == 200){ 
              this.optionsCategory = response.data
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e);
      }),
      eventBus.$on('Bus_ChangeLocale', (data) => {
        this.dataInit()
      })

  },
  

  watch: {
    IdUser: function (val) {
      this.dataInit()
    },
    FirstName: function (newWork, oldWork) {
      if(this.submited){
        this.validate()
      }
    },
    LastName: function (newWork, oldWork) {
      if(this.submited){
        this.validate()
      }
    },
    Email: function (newWork, oldWork) {
      if(this.submited){
        this.validate()
      }
    },
    Address: function (newWork, oldWork) {
      if(this.submited){
        this.validate()
      }
    },
    Password: function (newWork, oldWork) {
      if(this.submited){
        this.validate()
      }
    },
    selectedCategory: function (newWork, oldWork) {
      this.DisplayCategory = null //setting this to null will show the selected text
      if(this.submited){
        this.validate()
      }
    },
    MonthlyWage: function(monthlyWage){
      this.calcHourlyWage()
    },
    HoursMonthlyWage: function(hoursMonthlyWage){
      this.calcHourlyWage()
    }
  },

}

function error(err) {
  console.log(`ERROR(${err.code}): ${err.message}`);
}

function validateEmail(email) 
{
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
}

function testPassword(pwString) {
    var strength = 0;

    strength += /[A-Z]+/.test(pwString) ? 1 : 0;
    strength += /[a-z]+/.test(pwString) ? 1 : 0;
    strength += /[0-9]+/.test(pwString) ? 1 : 0;
    strength += /[\W]+/.test(pwString) ? 1 : 0;

    switch(strength) {
        case 3:
            // its's medium!
            return true
            break;
        case 4:
            // it's strong!
            return true
            break;
        default:
            // it's weak!
            return false
            break;
    }
}

function round(value, decimals) {
  return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
}

</script>

<style scoped>
.error {
  color: red;
}
</style>
